import axios from 'axios';
import WebApi from '../WebApi';
class AuthWebApi extends WebApi {
    async login({ password, email }) {
        return axios.post(`${this.urlPrefix}/users/authenticate`, {
            'user': {
                email,
                password,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    ;
    async saasAuthenticate({ password, email }, account) {
        return axios.post(`${this.urlPrefix}/saas/authenticate`, {
            'user': {
                email,
                password,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-User-Account': account,
            },
        });
    }
    ;
    async ssoAuth(code) {
        return axios.post(`${this.ssoPrefix}/api/sso_saas/authenticate `, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${code}`,
            },
        });
    }
    ;
    async googleAuth(token, account) {
        return axios.post(`${this.ssoPrefix}/api/v1/users/g_authenticate`, {
            user: { token },
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-User-Account': account,
            },
        });
    }
    ;
    async resetSendEmail({ email }) {
        return axios.post(`${this.urlPrefix}/users/reset`, {
            'user': {
                email,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    ;
    async getAuth(token, name, nonce) {
        return axios.post(`${this.urlPrefix}/ima_protect/authenticate`, {}, {
            headers: {
                Authorization: `Bearer ${token} - ${name} - ${nonce}`,
            },
        });
    }
    async resetPassword({ old_password, new_password }, userId) {
        return axios.post(`${this.urlPrefix}/users/${userId}/change_password`, {
            'user': {
                old_password,
                new_password,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async editUserAccount(payload, userId) {
        return axios.put(`${this.urlPrefix}/managers/${userId}`, {
            'manager': payload,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async editUser({ first_name, last_name, email, phone }, userId) {
        return axios.put(`${this.urlPrefix}/accounts/${userId}`, {
            'account': {
                first_name,
                last_name,
                email,
                phone,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
}
const authWebApi = new AuthWebApi();
export { authWebApi as AuthWebApi, };
